import { render, staticRenderFns } from "./Fkinprocess.vue?vue&type=template&id=93986a12&scoped=true&"
import script from "./Fkinprocess.vue?vue&type=script&lang=js&"
export * from "./Fkinprocess.vue?vue&type=script&lang=js&"
import style0 from "./Fkinprocess.vue?vue&type=style&index=0&id=93986a12&scoped=true&lang=css&"
import style1 from "./Fkinprocess.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93986a12",
  null
  
)

export default component.exports
import {QLayout,QPageContainer,QPage,QCard,QCardSection,QTimeline,QTimelineEntry,QChip} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QLayout,QPageContainer,QPage,QCard,QCardSection,QTimeline,QTimelineEntry,QChip})
